





























































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {DxScrollView} from 'devextreme-vue';
import HeaderSet from '@/components/HeaderSet/HeaderSet.vue';
import BlockCard from '@/components/InputComponents/block-card.vue';
import BlockInputs from '@/components/InputComponents/block-inputs.vue';
import BlockInputsLosses from '@/components/InputComponents/block-losses-inputs.vue';
import CardHeader from '@/components/InputComponents/card-header.vue'
import InputsHeader from '@/components/InputComponents/inputs-header.vue';
import PresetService from '@/services/user_preset_service';
import dicts_cache_service from '@/services/dicts_cache_service';
import {AcceptData, OkHnRow} from '@/services/models-service';
import LossesInputService from '@/services/losses_input_service';
import _ from 'lodash';
import acceptService from '@/services/accept-service';
import UserAccessService from '@/services/user_access_service';
import {DxLoadPanel} from 'devextreme-vue/load-panel';
import {alert, confirm} from 'devextreme/ui/dialog';
import DxDrawer from 'devextreme-vue/drawer';
import {aggregate_periods} from '@/constants';
import ExcelPasteHint from '@/components/ExcelPasteHint/index.vue';
import ImbalanceTable from "@/components/InputComponents/imbalance-table.vue";

class Item {
  name: string;
  display: string;
}

@Component({
  name: 'Losses',
  components: {
    ImbalanceTable,
    DxScrollView,
    HeaderSet,
    BlockCard,
    BlockInputs,
    InputsHeader,
    CardHeader,
    BlockInputsLosses,
    DxLoadPanel,
    DxDrawer,
    ExcelPasteHint
  }
})

export default class extends Vue {
  public facilityName: string = '';

  public preset_service = PresetService;
  public service = LossesInputService;
  public block_dict = dicts_cache_service.ok_hn_blocks;
  public block_ds: any[] = [];
  public showBlocks: any[] = [];
  // Флаг показа данных доп срезки
  public secondaryCutIsVisible = false;

  public header = 'Параметр';
  public set_periods: any = [];
  public selected_periods: any = [];
  public listToAggregate: any = [];
  public aggregatePeriods: any = [];
  public emptyData: any = {};
  public startLoading: boolean = false;
  public disableSave: boolean = true;
  public showNoBlocks: boolean = false;

  //названия срезок для inputs-header
  public mainCutName: string = '';
  public secondaryCutName: string = '';

  //Данные страницы
  public all_data: any = [];
  public blocksData: any = {};
  public all_secondary: any = [];
  public secondaryData: any = {};

  //отслеживание изменений
  public changed: any[] = [];
  public changedData: any = {};

  public currentAccept: any = {};
  public acceptPeriods: any = {};
  public facility_ds: any[] = [];
  // флаг акцепты загружены
  public acceptsIsReady: boolean = true;

  public rowVisible: any = {
    first: true,
    second: true,
    third: true,
    fourth: true,
    fifth: true,
    sixth: true,
  };

  public keys = [
    {id: 1, name: 'first'},
    {id: 2, name: 'second'},
    {id: 3, name: 'third'},
    {id: 4, name: 'fourth'},
    {id: 5, name: 'fifth'},
    {id: 6, name: 'sixth'},
    {id: 7, name: 'steam_total'},
    {id: 8, name: 'total'}];

  // Максимальное количество строк в блоке
  public readonly MAX_ROWS_PER_BLOCK = 6;

  public month: any = {
    1: 'january',
    2: 'february',
    3: 'march',
    4: 'april',
    5: 'may',
    6: 'june',
    7: 'july',
    8: 'august',
    9: 'september',
    10: 'october',
    11: 'november',
    12: 'december'
  }
  public ignoreRootNodesList: string[] = ['months', 'quarters', 'halfyears', 'year_item', 'growth', 'wane'];

  public block_permissions: any = {};
  public loading_animation: boolean = false;
  public showExcelHint: boolean = false;

  // Свойства для контроля вставки данных
  public globalPasteData: number[][] | null = null;
  public globalPasteStartRow: number = 0;
  public globalPasteStartCol: number = 0;
  public globalPasteTargetBlock: string | null = null;
  public globalPasteTargetPeriod: string | null = null;
  public imbalanceStruct: any = {};

  public headerHeight: any = 0;
  public arrowHeight: any = 0;

  public selectedRowIndex: { rowIndex: number; period: string; blockId?: string } = { rowIndex: -1, period: '', blockId: '' };

  public inputsHeaderWidth: number = 0;
  private inputsHeaderObservers: Map<string, any> = new Map();
  private inputsHeaderWidths: Map<string, number> = new Map();
  
  public cardHeaderWidth: number = 0;
  private cardHeaderObserver: any = null;

  onRowClicked(payload: { rowIndex: number, period: string, blockId: string }) {
    this.selectedRowIndex = payload;
    
  }

  mounted() {
    const headerEl = this.$refs.header as HTMLElement;
    const arrowEl = this.$refs.arrow as HTMLElement;
    if (headerEl && arrowEl) {
      this.headerHeight = `calc(100% - ${(headerEl.clientHeight + arrowEl.clientHeight)}px)`;
      this.arrowHeight = `calc(100% - ${arrowEl.clientHeight}px)`;
      console.log("Header height:", headerEl.clientHeight);
    }

    // Инициализация отслеживания ширины
    this.$nextTick(() => {
      this.initializeInputsHeaderTracking();
      this.initializeCardHeaderTracking();
    });
  }

  beforeDestroy() {
    this.cleanupInputsHeaderObservers();
    this.cleanupCardHeaderObserver();
  }

  private initializeInputsHeaderTracking(): void {
    if (!this.selected_periods || this.selected_periods.length === 0) {
      return;
    }

    this.selected_periods.forEach((period: string) => {
      this.setupInputsHeaderObserver(period);
    });
  }

  private setupInputsHeaderObserver(period: string): void {
    try {
      // Проверяем поддержку ResizeObserver
      if (typeof window === 'undefined' || !(window as any).ResizeObserver) {
        return;
      }

      const refName = `inputsHeader_${period}`;
      const refElement = (this.$refs[refName] as any);
      
      if (!refElement || (Array.isArray(refElement) && refElement.length === 0)) {
        return;
      }

      // Получаем DOM элемент
      const element = Array.isArray(refElement) ? refElement[0].$el : refElement.$el;
      
      if (!element) {
        return;
      }

      // Очищаем предыдущий observer если существует
      if (this.inputsHeaderObservers.has(period)) {
        const oldObserver = this.inputsHeaderObservers.get(period);
        if (oldObserver) {
          oldObserver.disconnect();
        }
      }

      // Создаём новый ResizeObserver
      const ResizeObserverConstructor = (window as any).ResizeObserver;
      const observer = new ResizeObserverConstructor((entries: any[]) => {
        entries.forEach((entry: any) => {
          const width = entry.contentRect.width;
          
          // Сохраняем ширину для каждого периода
          this.inputsHeaderWidths.set(period, width);
          
          // Устанавливаем основную ширину (используем ширину первого периода)
          if (!this.inputsHeaderWidth || this.selected_periods[0] === period) {
            this.inputsHeaderWidth = width;
          }
        });
      });

      // Начинаем наблюдение
      observer.observe(element);
      this.inputsHeaderObservers.set(period, observer);
      
      // Устанавливаем начальную ширину
      const initialWidth = element.offsetWidth;
      if (initialWidth > 0) {
        this.inputsHeaderWidths.set(period, initialWidth);
        if (!this.inputsHeaderWidth || this.selected_periods[0] === period) {
          this.inputsHeaderWidth = initialWidth;
        }
      }

    } catch (error) {
      console.error(`Ошибка настройки обсервера для периода: ${period}:`, error);
    }
  }

  private cleanupInputsHeaderObservers(): void {
    this.inputsHeaderObservers.forEach((observer: any) => {
      observer.disconnect();
    });
    this.inputsHeaderObservers.clear();
    this.inputsHeaderWidths.clear();
  }


  private initializeCardHeaderTracking(): void {
    this.$nextTick(() => {
      this.setupCardHeaderObserver();
    });
  }

  private setupCardHeaderObserver(): void {
    try {
      const cardHeaderElement = this.$refs.cardHeaderContainer as HTMLElement;
      
      if (!cardHeaderElement) {
        console.warn('Card header container element not found');
        return;
      }

      if (this.cardHeaderObserver) {
        this.cardHeaderObserver.disconnect();
      }

      const ResizeObserverConstructor = (window as any).ResizeObserver;
      const observer = new ResizeObserverConstructor((entries: any[]) => {
        entries.forEach((entry: any) => {
          const width = entry.contentRect.width;
          this.cardHeaderWidth = width;
        });
      });

      observer.observe(cardHeaderElement);
      this.cardHeaderObserver = observer;

      const initialWidth = cardHeaderElement.offsetWidth;
      if (initialWidth > 0) {
        this.cardHeaderWidth = initialWidth;
      }

      console.log(`Initial card-header width: ${initialWidth}px`);

    } catch (error) {
      console.error('Error setting up card-header observer:', error);
    }
  }

  private cleanupCardHeaderObserver(): void {
    if (this.cardHeaderObserver) {
      this.cardHeaderObserver.disconnect();
      this.cardHeaderObserver = null;
    }
    this.cardHeaderWidth = 0;
  }


  handleImbalance(data: any): void {
    this.imbalanceStruct = data
  }

  // handleShowImbalance(val: boolean): void {
  //   this.isImbalanceVisible = val;
  // }

  get cssVars() {
    return {
      '--width': this.preset_service.cardWidth + 'px'
    }
  }

  async exportData() {
    const exportFilter = this.preset_service.createExportToExcelFilterObject(this.$route?.name || 'losses');
    if (exportFilter) {
      await this.service.exportToExcel(exportFilter,
        this.mainCutName ? `Потери_${this.mainCutName.replace(' ', '_')}_${exportFilter.id_eco_facility}` : null)
    }
  }

  async onSave() {
    this.loading_animation = true;
    let pack: OkHnRow[] = [];
    //преобразуем данные в массив объектов для отправки на бэк
    this.changed.forEach(ch => {
      if (this.aggregatePeriods.includes(ch.period)) return;
      for (let row in this.blocksData[ch.block][ch.period]) {
        delete this.blocksData[ch.block][ch.period][row].isFocused;
        pack.push(this.blocksData[ch.block][ch.period][row])
      }
    });
    await this.service.save(pack);
    await this.getSavedTotalData();
    this.changed = [];
    this.changedData = {}
    
    // todo проверить, что ничего не ломает отключение повторной загрузки
    
    Vue.nextTick(() => {
      this.loading_animation = false
      
    });

  }

  async getLoad() {
    this.showNoBlocks = false;
    if (this.changed.length > 0) {
      const answer = await confirm('Имеются несохранённые изменения. Сохранить?', 'Сохранение')
      if (answer) {
        await this.onSave();
      } else {
        this.changed = [];
      }
    }
    if (!this.showBlocks?.length) {
      this.loading_animation = false;
      this.startLoading = false;
      this.showNoBlocks = true;
      return
    }

    this.startLoading = false;
    this.loading_animation = true;
    this.acceptPeriods = {};
    this.listToAggregate = [];
    this.aggregatePeriods = [];
    // загружаем данные для текущего пресета
    if (this.preset_service.currentPreset && this.preset_service.currentPreset.id_cut && this.preset_service.currentPreset.id_eco_facility &&
      this.preset_service.currentPreset.id_eco_heat_node) {
      this.block_ds = this.showBlocks;
      console.log('this.showBlocks');
      console.log(this.showBlocks);
      // Отображать только месяцы соответствующие времени жизни выбранного объекта
      this.set_periods = this.preset_service.period_filtered;
      this.selected_periods = this.preset_service.currentPreset.period.slice().filter((p: string) => !this.ignoreRootNodesList.includes(p));
      this.blocksData = this.createStructure();
      this.emptyData = _.cloneDeep(this.blocksData);
      // Логика для дополнительной срезки теперь обрабатывается через handleSecondaryCutInfo
      this.secondaryCutIsVisible = false;
      this.secondaryData = {};
      this.block_permissions = UserAccessService.checkEditingBlocks(this.preset_service.currentPreset.id_eco_heat_node);

      const loadResp = async () => {
        if (this.preset_service.currentPreset.id_eco_facility && this.preset_service.currentPreset.id_cut) {
          const resp = await this.service.getWithFilter(this.preset_service.currentPreset.id_cut, this.preset_service.currentPreset.id_eco_facility, this.set_periods);
          if (resp) {
            this.all_data = resp;
          }
        }
      }
      await loadResp();

      const accept_resp = acceptService.GetAcceptDict();  // await acceptService.getWithFilter([this.preset_service.currentPreset.id_cut,])
      if (accept_resp && (this.preset_service.currentPreset.id_cut in accept_resp)) {
        let object_id = this.preset_service.currentPreset.id_eco_facility;
        this.currentAccept = accept_resp[this.preset_service.currentPreset.id_cut].filter(acc => acc.id_eco_facility === object_id);
        this.currentAccept.forEach((acc: any) => {
          if (this.set_periods.includes(this.month[acc.month])) {
            this.acceptPeriods[this.month[acc.month]] = acc.blocks
          }
        });
      }
    }
    

    this.parseData(this.blocksData, this.all_data);
    if (this.all_secondary && this.secondaryData) {
      this.parseData(this.secondaryData, this.all_secondary);
    }

    //команда на отрисовку таблицы
    Vue.nextTick(() => {
      this.startLoading = true;
      this.$nextTick(() => {
        this.initializeInputsHeaderTracking();
        this.initializeCardHeaderTracking();
      });
    });

    setTimeout(() => {
      this.loading_animation = false;
      this.changed = []
    }, 500);

    sessionStorage.setItem(`inputLoadedData_${this.$route.name}`, 'true');
  }

  createStructure() {
    let structure: any = {};
    //создаем структуру данных
    this.showBlocks.forEach((block: Item) => {
      structure[block.name] = {};
    });
    this.selected_periods.forEach((period: string) => {
      if (aggregate_periods.hasOwnProperty(period) && !this.aggregatePeriods.includes(period)) {
        this.aggregatePeriods.push(period);
        this.listToAggregate.push.apply(this.listToAggregate, aggregate_periods[period]);
      }
      for (let block in structure) {
        structure[block][period] = {};
        this.keys.forEach(k => {
          let row = new OkHnRow()
          row.block = block;
          row.month = period;
          if (k.name === 'total') {
            row.is_total_block = true;
          } else if (k.name === 'steam_total') {
            row.is_steam_total_block = true;
          } else {
            row.id_heat_carrier = k.id;
          }
          if (this.preset_service.currentPreset && this.preset_service.currentPreset.id_cut && this.preset_service.currentPreset.id_eco_facility && this.preset_service.currentPreset.id_eco_heat_node) {
            row.id_cut = this.preset_service.currentPreset.id_cut;
            row.id_eco_facility = this.preset_service.currentPreset.id_eco_facility;
            row.id_eco_heat_node = this.preset_service.currentPreset.id_eco_heat_node;
          }
          structure[block][period][k.name] = row;
        });
      }
    })
    return structure;
  }

  parseData(target: any, data: any) {

    // распарсиваем данные по блокам и периодам
    data.forEach((row: OkHnRow) => {
      if (target[row.block] && target[row.block].hasOwnProperty(row.month)) {
        if (row.is_total_block) {
          target[row.block][row.month]['total'] = row;
        }
        if (row.is_steam_total_block) {
          target[row.block][row.month]['steam_total'] = row;
        }
        if (row.id_heat_carrier) {
          const idx = this.keys.find(k => k.id === row.id_heat_carrier)
          if (idx) {
            target[row.block][row.month][idx.name] = row;
          }
        }
      }
      if (this.listToAggregate.includes(row.month)) {
        this.aggregatePeriods.forEach((period: any) => {
          if (target[row.block] && aggregate_periods[period].includes(row.month)) {
            if (row.is_total_block) {
              target[row.block][period]['total'].vol_te += row.vol_te;
            }
            if (row.is_steam_total_block) {
              target[row.block][period]['steam_total'].vol_te += row.vol_te;
            }
            if (row.id_heat_carrier) {
              const idx = this.keys.find(k => k.id === row.id_heat_carrier)
              if (idx) {
                target[row.block][period][idx.name].vol_te += row.vol_te;
              }
            }
          }
        });
      }
    });
  }

  async getSavedTotalData() {
    if (this.preset_service.currentPreset.id_cut && this.preset_service.currentPreset.id_eco_facility) {
      let savedData: any[] = [];
      const changedBlocks = this.changed.map(c => c.block);
      const response: any = await this.service.getChanged(this.preset_service.currentPreset.id_cut, this.preset_service.currentPreset.id_eco_facility, changedBlocks, this.selected_periods);
      if (response) {
        savedData = response;
      }
      savedData.forEach((row: OkHnRow) => {
        if (this.blocksData[row.block] && this.blocksData[row.block].hasOwnProperty(row.month)) {
          if (row.is_total_block) {
            this.blocksData[row.block][row.month]['total'] = row;
          }
          if (row.is_steam_total_block) {
            this.blocksData[row.block][row.month]['steam_total'] = row;
          }
          if (row.id_heat_carrier) {
            const idx = this.keys.find(k => k.id === row.id_heat_carrier)
            if (idx) {
              this.blocksData[row.block][row.month][idx.name] = row;
            }
          }
        }
      });
    }
  }

  seekChanges(changes: any) {
    // loading_animation также позволяет экранировать накопление данных об изменениях, пока идёт загрузка данных,
    // так как тогда отработает вотчер для данных в компоненте block-losses-input и станет активна кнопка "Сохранить"
    // в то время как на самом деле данные ещё НЕ были изменены самим пользователем в рамках текущей сессии
    if (this.loading_animation) {
      return
    }

    this.calculateSum(this.blocksData[changes.block][changes.period]);
    if (changes.block !== 'total' && !aggregate_periods.hasOwnProperty(changes.period)) this.changedData = _.cloneDeep(this.blocksData[changes.block][changes.period]);
    if (!this.changed.find(c => c.block === changes.block && c.period === changes.period)) {
      this.changed.push(changes);
    }
    if (this.aggregatePeriods.length > 0 && !this.aggregatePeriods.includes(changes.period)) {
      this.calculateAgg(changes.block);
    }
  }

  giveName(names: any) {
    this.mainCutName = names.name;
    this.secondaryCutName = names.secondary;
    console.log('giveName called with:', names);
  }

  handleSecondaryCutInfo(info: any) {
    console.log('handleSecondaryCutInfo called with:', info);
    if (info.hasSecondaryCut && info.secondaryCut) {
      this.secondaryCutIsVisible = true;
      this.secondaryCutName = info.secondaryCut.name;
      // Загружаем данные по дополнительной срезке
      this.loadSecondaryCutData(info.secondaryCutId);
    } else {
      this.secondaryCutIsVisible = false;
      this.secondaryCutName = '';
      this.secondaryData = {};
    }
  }

  async loadSecondaryCutData(secondaryCutId: string) {
    if (this.preset_service.currentPreset.id_eco_facility && secondaryCutId) {
      console.log('Loading secondary cut data for:', secondaryCutId);
      this.secondaryData = this.createStructure();
      const secondary_resp = await this.service.getWithFilter(secondaryCutId, this.preset_service.currentPreset.id_eco_facility, this.set_periods);
      if (secondary_resp) {
        this.all_secondary = secondary_resp;
        this.parseData(this.secondaryData, this.all_secondary);
        console.log('Secondary cut data loaded:', this.all_secondary);
      }
    }
  }

  getBlocks({ blocks, facilityName }: { blocks: any, facilityName: string }) {
      this.facilityName = facilityName;
      this.showNoBlocks = Object.values(blocks).every(arr => (arr as any[]).length === 0);

      let result: any[] = [];
      if(blocks.ok_hn_blocks.length) {
        this.block_dict.forEach((block: any) => {
          blocks.ok_hn_blocks.forEach((show_block: any) => {
            if(show_block.block === block.name) result.push(block);
          });
        });
      }
      this.showBlocks = result;
    }

  calculateSum(target: any) {
    let steam_total = 0;
    for (let key in target) {
      this.keys.forEach(k => {
        if (k.name === key) {
          if (k.name === 'first' || k.name === 'total' || k.name === 'steam_total') return;
          steam_total += target[key].vol_te;
        }
      });
    }
    target.steam_total.vol_te = steam_total;
    target.total.vol_te = target.steam_total.vol_te + target.first.vol_te;
  }

  calculateAgg(block: any) {
    let blockSum = _.cloneDeep(this.emptyData[block]);
    this.all_data.forEach((row: OkHnRow) => {
      if (row.block === block && !this.selected_periods.includes(row.month) && this.listToAggregate.includes(row.month)) {
        this.aggregatePeriods.forEach((period: any) => {
          if (aggregate_periods[period].includes(row.month)) {
            if (row.is_total_block) {
              blockSum[period]['total'].vol_te += row.vol_te;
            }
            if (row.is_steam_total_block) {
              blockSum[period]['steam_total'].vol_te += row.vol_te;
            }
            if (row.id_heat_carrier) {
              const idx = this.keys.find(k => k.id === row.id_heat_carrier)
              if (idx) {
                blockSum[period][idx.name].vol_te += row.vol_te;
              }
            }
          }
        });
      }
    });
    for (let month in this.blocksData[block]) {
      if (this.aggregatePeriods.includes(month)) continue;
      for (let key in this.blocksData[block][month]) {
        const row = this.blocksData[block][month][key]
        this.aggregatePeriods.forEach((period: any) => {
          if (aggregate_periods[period].includes(row.month)) {
            if (row.is_total_block) {
              blockSum[period]['total'].vol_te += row.vol_te;
            }
            if (row.is_steam_total_block) {
              blockSum[period]['steam_total'].vol_te += row.vol_te;
            }
            if (row.id_heat_carrier) {
              const idx = this.keys.find(k => k.id === row.id_heat_carrier)
              if (idx) {
                blockSum[period][idx.name].vol_te += row.vol_te;
              }
            }
            this.blocksData[row.block][period] = _.cloneDeep(blockSum[period]);
          }
        });
      }
    }
  }

  @Watch('changed')
  saveWatcher() {
    if (this.changed.length > 0) {
      this.disableSave = false;
    } else {
      this.disableSave = true;
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.loading_animation) {
      // Во время сохранения данных не сразу выполнять переход на следующую, а дождаться выполнения сохранения
      let tickCount = 0;
      const intId = setInterval(() => {
        tickCount++
        // ТАккже предосмотреть выход по истечении заданного интервала
        if (!this.loading_animation || tickCount > 20) {
          clearInterval(intId)
          next()
        }
      }, 200)
    } else if (this.changed.length > 0) {
      confirm('Имеются несохранённые изменения. Сохранить?', 'Сохранение')
        .then((answer: boolean) => {
          if (answer) {
            this.onSave();
            next();
          } else {
            next();
          }
        });
    } else {
      next();
    }
  }

  resendFacilities(facilities: any) {
    this.facility_ds = facilities
  }

  onAcceptLoaded(value: boolean) {
    this.acceptsIsReady = value;
  }

  hideExcelHint() {
    this.showExcelHint = false;
  }

  // Метод для обработки запросов на вставку от дочерних компонентов
  handlePasteRequest(pasteInfo: any) {
    console.log('Получен запрос на вставку:', pasteInfo);

    const {matrix, blockId, periodName, startRow, startCol} = pasteInfo;

    // Определяем, нужно ли распространить вставку на другие блоки
    // Теперь применяем глобальную вставку для всех случаев, кроме одиночного значения
    const rows = matrix.length;
    const cols = matrix[0]?.length || 0;
    const shouldSpreadToOtherBlocks = (rows > 1 || cols > 1);

    if (shouldSpreadToOtherBlocks) {
      // Устанавливаем глобальные параметры вставки
      this.globalPasteData = matrix;
      this.globalPasteStartRow = startRow;
      this.globalPasteStartCol = startCol;
      this.globalPasteTargetBlock = blockId;
      this.globalPasteTargetPeriod = periodName;

      // Применяем вставку ко всем подходящим блокам
      this.applyGlobalPaste();
    }
  }

  // Метод для применения глобальной вставки
  applyGlobalPaste() {
    if (!this.globalPasteData || !this.globalPasteTargetBlock || !this.globalPasteTargetPeriod) {
      return;
    }

    console.log(`Применение глобальной вставки: ${this.globalPasteData.length}x${this.globalPasteData[0]?.length || 0}`);

    // Определяем тип вставки
    const rows = this.globalPasteData.length;
    const cols = this.globalPasteData[0]?.length || 0;

    this.applyMatrixGlobalPaste();

    this.clearGlobalPaste();
  }

  // Метод для применения значения к конкретной строке блока
  applyValueToBlockRow(blockName: string, periodName: string, rowIndex: number, value: number) {
    if (!this.blocksData[blockName] || !this.blocksData[blockName][periodName]) {
      return;
    }

    const keys = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'];
    const targetKey = keys[rowIndex];

    const num = this.parseToNumber(value);
    this.blocksData[blockName][periodName][targetKey].vol_te = num;

    // сразу пересчитать суммы и пометить изменения
    this.calculateSum(this.blocksData[blockName][periodName]);
    this.markChanged(blockName, periodName);
  }

  private markChanged(block: string, period: string) {
    // не добавляем дубликаты
    if (!this.changed.find(c => c.block === block && c.period === period)) {
      this.changed.push({ block, period });
    }
    // обновим snapshot данных для onSave
    if (!aggregate_periods.hasOwnProperty(period)) {
      this.changedData = _.cloneDeep(this.blocksData[block][period]);
    }
    if (this.aggregatePeriods.length > 0 && !this.aggregatePeriods.includes(period)) {
      this.calculateAgg(block);
    }
  }

  // Метод для матричной вставки (несколько строк и столбцов)
  applyMatrixGlobalPaste() {
    if (!this.globalPasteData) return;

    const rows = this.globalPasteData.length;
    const cols = this.globalPasteData[0]?.length || 0;

    console.log(`Матричная вставка: ${rows}x${cols} начиная с позиции (${this.globalPasteStartRow}, ${this.globalPasteStartCol})`);

    // Определяем, как интерпретировать матрицу:
    // По умолчанию считаем что строки = периоды, столбцы = блоки
    // Это более интуитивно для пользователей Excel

    console.log('Интерпретация: строки = периоды, столбцы = блоки');
    this.applyMatrixAsPeriodsAndBlocks();
  }

  private parseToNumber(v: any): number {
    if (v === null || v === undefined) return 0;
    if (typeof v === 'number' && isFinite(v)) return v;

    // Нормализуем строку: убираем неразрывные/узкие пробелы, обычные пробелы внутри числа,
    // меняем запятую на точку, тримим
    const s = String(v)
      .replace(/\u00A0|\u202F/g, '')     // NBSP / narrow no-break space
      .replace(/\s+/g, '')               // обычные пробелы (в т.ч. "113. 7")
      .replace(',', '.')
      .trim();

    const n = parseFloat(s);
    return isNaN(n) || !isFinite(n) ? 0 : n;
  }

  // Метод для интерпретации матрицы как периоды и блоки
  applyMatrixAsPeriodsAndBlocks() {
    if (!this.globalPasteData) return;

    const rows = this.globalPasteData.length;
    const cols = this.globalPasteData[0]?.length || 0;

    console.log(`Применение матрицы как периоды и блоки: ${rows}x${cols}`);
    console.log(`Целевой блок: ${this.globalPasteTargetBlock}, целевой период: ${this.globalPasteTargetPeriod}`);
    console.log(`Начальная строка: ${this.globalPasteStartRow}, начальный столбец: ${this.globalPasteStartCol}`);
    console.log(`Доступные блоки:`, this.block_ds.map(b => b.name));
    console.log(`Доступные периоды:`, this.selected_periods);

    // Находим индекс целевого блока
    const targetBlockIndex = this.block_ds.findIndex(block => block.name === this.globalPasteTargetBlock);

    // Меняем местами: строки матрицы = строки блока, столбцы матрицы = периоды
    for (let rowIndex = 0; rowIndex < rows; rowIndex++) {
      // rowIndex определяет строку внутри блока (first, second, third, etc.)
      const targetRowIndex = this.globalPasteStartRow + rowIndex;
      const row = this.globalPasteData[rowIndex];

      console.log(`Обработка строки ${rowIndex}: строка блока ${targetRowIndex}, значения [${row.join(', ')}]`);

      // Определяем, в какой блок вставлять данные
      const blockOffset = Math.floor(targetRowIndex / this.MAX_ROWS_PER_BLOCK);
      const actualRowIndex = targetRowIndex % this.MAX_ROWS_PER_BLOCK;
      const targetBlockIndexWithOffset = targetBlockIndex + blockOffset;

      // Проверяем, существует ли блок с таким индексом
      if (targetBlockIndexWithOffset >= 0 && targetBlockIndexWithOffset < this.block_ds.length) {
        const targetBlock = this.block_ds[targetBlockIndexWithOffset];

        console.log(`  Строка ${targetRowIndex} будет вставлена в блок ${targetBlock.name} (индекс ${targetBlockIndexWithOffset}) на позицию ${actualRowIndex}`);

        for (let colIndex = 0; colIndex < cols; colIndex++) {
          // colIndex определяет период
          const targetPeriodIndex = this.selected_periods.findIndex((period: any) => period === this.globalPasteTargetPeriod) + colIndex;

          if (targetPeriodIndex >= 0 && targetPeriodIndex < this.selected_periods.length) {
            const targetPeriod = this.selected_periods[targetPeriodIndex];
            const value = row[colIndex];

            console.log(`    Столбец ${colIndex}: период ${targetPeriod}, блок ${targetBlock.name}, значение ${value}`);

            this.applyValueToBlockRow(targetBlock.name, targetPeriod, actualRowIndex, value);
          } else {
            console.log(`    Столбец ${colIndex}: период с индексом ${targetPeriodIndex} не найден`);
          }
        }
      } else {
        console.log(`  Блок с индексом ${targetBlockIndexWithOffset} не найден, пропускаем строку ${rowIndex}`);
      }
    }
  }

  // Метод для очистки глобальных параметров вставки
  clearGlobalPaste() {
    this.globalPasteData = null;
    this.globalPasteStartRow = 0;
    this.globalPasteStartCol = 0;
    this.globalPasteTargetBlock = null;
    this.globalPasteTargetPeriod = null;
  }

  get noBlocksMessage() {
    const sectionMap: Record<string, string> = {
      losses: 'Потери',
      buy: 'Покупка',
      sale: 'Реализация',
      transport_cost: 'Затраты на транспорт',
      transport_gain: 'Выручка за транспорт'
    };
    const routeName = this.$route && this.$route.name ? this.$route.name : '';
    const section = sectionMap[routeName] || routeName;

    return `Для объекта «${this.facilityName}» в разделе «${section}» нет блоков, доступных для заполнения. Обратитесь к администратору.`;
  }

  public hideHeader: boolean = true;

    created() {
      if(!_.isNil(sessionStorage.getItem('hideHeader'))) {
        const match = sessionStorage.getItem('hideHeader');
        if(match) {
          const settings = JSON.parse(match);
          if(settings.user_id === localStorage.getItem('user_id')) this.hideHeader = (settings.state === 'true');
        }
      }
    }

    switchToogle() {
      this.hideHeader = !this.hideHeader;
      sessionStorage.setItem(`hideHeader`, `{"user_id": "${localStorage.getItem('user_id')}", "state": "${this.hideHeader}"}`);
    }
}
